/**
 * @generated SignedSource<<bb973ac08203485b28af0ad46d657d2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentReplyFragment$data = {
  readonly commentId: UUID;
  readonly flow: {
    readonly assignedToId: UUID | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly flowId: UUID;
  readonly " $fragmentType": "CommentReplyFragment";
};
export type CommentReplyFragment$key = {
  readonly " $data"?: CommentReplyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentReplyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentReplyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedToId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentId",
      "storageKey": null
    }
  ],
  "type": "FlowComment",
  "abstractKey": null
};

(node as any).hash = "884815cab64d5cc908feefd6076720ed";

export default node;
